import React, { useRef, useEffect } from 'react';
import './Photo.css';
import fb from '../Photoset/fb.png';
import PhotoSlider from './PhotoSlider';
import PhotoSlider2 from './PhotoSlider2';
import Footer from './Footer';

function Photo() {
    return (
        <div className='phrase'>
            <div className='text-phrase'>
                <h >"ถ้าอยากแปลกต้องแตกต่าง ถ้าอยากแปกป่างต้องปากแตก"</h>
                <h>---------------------------------------------------------------------------------</h>
            </div>
            <p>นายสุชาต วิริยะ ตำแหน่ง ผู้อำนวยการสถานศึกษา</p>
            <div className='all-fb-map'>
            <div className='fb'>
                <div class="fb-page" data-href="https://www.facebook.com/profile.php?id=100057449049222" data-tabs="timeline" data-width="520" data-height="350" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/profile.php?id=100057449049222" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/profile.php?id=100057449049222"><img src={fb} alt="fb" /></a></blockquote></div></div>
            <div className='map'>
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3844.146480557285!2d103.19183047431693!3d15.530276253642256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311837c99f7f7885%3A0x4291ad1b9059cb74!2z4LmC4Lij4LiH4LmA4Lij4Li14Lii4LiZ4LmA4LiX4Lio4Lia4Liy4Lil4LiV4Liz4Lia4Lil4Lie4Lii4Lix4LiE4LiG4Lig4Li54Lih4Li04Lie4Li04Liq4Lix4Lii!5e0!3m2!1sth!2sth!4v1714108464230!5m2!1sth!2sth" 
                    width="600" 
                    height="400" 
                    style={{ border: '0' }} // Converted style to object style
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
            </div>
            <div className='slider-ac'>
                <PhotoSlider/>
            <PhotoSlider2/>
            </div>
            
            <Footer/>
        </div>
    )
}

export default Photo